import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';

import App from './pages/App/App';
import MagicLink from './pages/MagicLink/MagicLink';
import SignUp from './pages/SignUp/SignUp';

const AppRouter = () => (
  <Router>
    <Routes>
      <Route path="/magic-link" element={<MagicLink />} />
      <Route path="/sign-up" element={<SignUp />} />
      <Route path="/" element={<App activePage='dashboard' />} />
      <Route path="/f24-extraction" element={<App activePage='f24-extraction' />} />
      <Route path="/marelli-registri-iva" element={<App activePage='marelli-registri-iva' />} />
      <Route path="/dm10-reading" element={<App activePage='dm10-reading' />} />
      <Route path="/f24-summarize" element={<App activePage='f24-summarize' />} />
    </Routes>
  </Router>
);

export default AppRouter;
